



















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
@Component({})
export default class Select35 extends Vue {
    @Prop({}) action!:string;
    @Prop({default:"12"}) md!:string;
    @Prop({default:false}) disabled!:boolean;
    @Prop({default:""}) updateAction!:string;
    @Prop({}) label!:string;
    @Prop({}) value!:string;
    @Prop({}) items!:[];
    @Prop({}) itemText!:string;
    @Prop({}) itemValue!:string;
    @Prop({}) changePropName!:string;
    @Prop({default:true}) required!:boolean;
    async updateValue (value:string) {
        let oldValue = this.value;
        this.$emit('input', value)
        if(this.updateAction != ""){
          try{
            let response = await this.$http.patch(this.updateAction+"?"+(this.changePropName?this.changePropName:this.itemValue)+"="+value);
            this.$emit("success",true);
          }catch (e) {
            this.$emit('input',oldValue);
          }
        }
    }
    async created(){
        if(!this.items){
            let response = await this.$http.get(this.action);
            /*
            var json : any = {};
            json[this.itemText] = "Seçiniz";
            json[this.itemValue] = null;
            json = [json];
            this.items = json;
             */
            this.items = response.data;
        }
    }
}
